const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var FlagSi16 = function FlagSi16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
      fill: "#D8DDE1",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M.5 9.4h15v2.05a1.4 1.4 0 0 1-1.4 1.4H1.9a1.4 1.4 0 0 1-1.4-1.4V9.4z",
      fill: "red",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M.5 5.95h15V9.4H.5V5.95z",
      fill: "#005CE5",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M.5 3.9a1.4 1.4 0 0 1 1.4-1.4h12.2a1.4 1.4 0 0 1 1.4 1.4v2.05H.5V3.9z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m4.824 4.315-.069.001a3.018 3.018 0 0 0-1.168.268 3.91 3.91 0 0 0-.095.042l.103 1.613c.07.842.62 1.333 1.23 1.526.61-.193 1.16-.684 1.231-1.526l.102-1.608a3.02 3.02 0 0 0-1.332-.316h-.001z",
      fill: "#005CE5",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m4.825 5.43-.3.589-.196-.253-.508.672c.009.042.02.082.031.122.057.096.166.205.306.205.112 0 .223-.089.334-.089.111 0 .222.09.333.09.111 0 .223-.09.334-.09.11 0 .222.09.333.09.139 0 .247-.108.305-.204a1.52 1.52 0 0 0 .032-.125l-.508-.671-.195.253-.3-.588zm-.333 1.335c-.111 0-.222.09-.334.09a.366.366 0 0 1-.222-.076c.021.044.043.086.067.127a.293.293 0 0 0 .155.047c.112 0 .223-.089.334-.089.111 0 .222.09.333.09.111 0 .223-.09.334-.09.11 0 .222.09.333.09a.292.292 0 0 0 .154-.047 1.53 1.53 0 0 0 .066-.127.366.366 0 0 1-.22.074c-.111 0-.222-.089-.333-.089-.111 0-.223.09-.334.09-.11-.001-.222-.09-.333-.09zm0 .188c-.111 0-.222.09-.334.09a.364.364 0 0 1-.069-.008c.192.257.455.429.736.528.28-.099.543-.27.735-.527a.366.366 0 0 1-.068.006c-.111 0-.222-.089-.333-.089-.111 0-.223.09-.334.09-.11 0-.222-.09-.333-.09z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.324 4.53h.252l-.126.219",
      fill: "#FFE500",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.576 4.677h-.252l.126-.219m.249.569h.252l-.126.219",
      fill: "#FFE500",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.951 5.173H4.7l.126-.218m.248-.425h.252l-.126.22",
      fill: "#FFE500",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.326 4.677h-.252l.126-.219",
      fill: "#FFE500",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.825 4.315zm-1.238.27a3.872 3.872 0 0 0-.095.041l.103 1.613c.07.843.62 1.333 1.23 1.526.61-.193 1.16-.683 1.231-1.526l.102-1.608a2.334 2.334 0 0 0-.095-.046l-.096 1.6c-.066.82-.576 1.297-1.142 1.484-.566-.187-1.076-.664-1.143-1.484l-.095-1.6z",
      fill: "red",
    })
  );
};
FlagSi16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  16: FlagSi16,
};
export function FlagSi(_ref) {
  let { size = "16" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["16"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'FlagSi' icon. Please use one of the available sizes: '16'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
